import React from 'react';
import { Select } from '../../../../select';
import styles from './dropdown-column.module.scss';
export const DropdownColumn = ({ data, colDef, }) => {
    const { ...restProps } = (colDef === null || colDef === void 0 ? void 0 : colDef.colId) ? data[colDef.colId] : {};
    return (React.createElement("div", { className: styles.dropdownCellContainer },
        React.createElement(Select.Dropdown, { "data-testid": restProps === null || restProps === void 0 ? void 0 : restProps.id, ...restProps, className: styles.dropdown })));
};
//# sourceMappingURL=dropdown-column.js.map